import React from "react";
import CostaMain from "../../Components/CostaMain/CostaMain";
import { useEffect, useState, useRef } from "react";
import assetService from "../../Services/assetService";
import ArticlesList from "../../Components/ArticlesList/ArticlesList";
import YearsList from "../../Components/YearsList/YearsList";
import { useSelector, useDispatch } from "react-redux";
import {
  clearFilters,
  setResults,
  clearResults,
  addResults,
} from "../../Reducers/filterReducer";
import SearchBar from "../../Components/Searchbar/SearchBar";
import XTimeline from "../../Components/SocialWidgets/XTimeline";
import FaceBookTimeline from "../../Components/SocialWidgets/FacebookTimeline";
import YouTubeSubscribe from "../../Components/SocialWidgets/YoutubeSubscribe";
import Slider from "../../Components/Slider/Slider";
import "./Home.css";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [highlights, setHighlights] = useState([]);
  const [next, setNext] = useState();

  const dispatch = useDispatch();

  const filters = useSelector((state) => state.filter.filters);
  const results = useSelector((state) => state.filter.results);
  const channelGuid = useSelector((state) => state.channel.channelGuid);

  const prevChannelGuid = useRef();

  useEffect(() => {
    return () => {
      dispatch(clearResults());
      dispatch(clearFilters());
    };
  }, []);

  useEffect(() => {
    const fetchAssets = async () => {
      let body = {
        filters,
        "limit": 12,
      };
      setIsLoading(true);

      try {
        let data;
        if (channelGuid) {
          data = await assetService.getAssets(channelGuid, body);
          setNext(data?.next);
          dispatch(setResults(data.items));

          if (
            prevChannelGuid.current !== channelGuid ||
            highlights.length === 0
          ) {
            setHighlights(data.items.slice(0, 4));
          }

          prevChannelGuid.current = channelGuid;
          if (
            (filters.fulltext === "" && data.items.length !== 0) ||
            filters.fulltext !== ""
          ) {
            setIsLoading(false);
          }
        }
      } catch (error) {
        console.error("Errore nel recupero degli articoli:", error);
        setIsLoading(false);
      }
    };
    fetchAssets();
  }, [filters, channelGuid]);

  const onSearch = async (result) => {
    dispatch(clearResults());
    dispatch(setResults(result));
  };

  const onClickMore = async () => {
    try {
      let body = {
        filters,
        "limit": 12,
        next,
      };

      if (channelGuid) {
        const moreData = await assetService.getAssets(channelGuid, body);
        setNext(moreData.next);
        dispatch(addResults(moreData.items));
      }
    } catch (error) {
      console.error("Errore nel recupero degli articoli:", error);
    }
  };

  return (
    <CostaMain>
      <div className="col-12 col-lg-9 left">
        <Slider slides={highlights} />
        <ArticlesList
          contents={results}
          isLoading={isLoading}
          getMoreAssets={onClickMore}
          next={next}
        />
      </div>
      <div className="col-12 col-lg-3 right">
        <SearchBar
          setIsLoading={setIsLoading}
          searchByText={(result, text) => onSearch(result, text)}
        />
        <YearsList />
        <YouTubeSubscribe />
        <FaceBookTimeline />
        <XTimeline />
      </div>
    </CostaMain>
  );
};

export default Home;
